<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='取消订单'">

    <div class="desc bgF border-box">
      <img class="icon-tip" src="../../assets/tip01.png" alt="">
      <p class="tip1" v-if="errmsg">{{errmsg}}</p>
      <p class="tip" v-else>您确定要取消该订单吗?</p>

      <div class="info" v-if="!errmsg">
        <div class="box" v-if="order.paytime">
          <div class="tit cor6">支付时间：</div>
          <div class="flex cor3">{{order.paytime}}</div>
        </div>
        <div class="box" v-if="order.paymoney">
          <div class="tit cor6">支付金额：</div>
          <div class="flex cor3">￥{{order.paymoney}}</div>
        </div>
        <div class="box" v-if="order.refundmoney">
          <div class="tit cor6">退款金额：</div>
          <div class="flex cor-p">￥{{order.refundmoney}}</div>
        </div>
        <div class="box" v-if="order.note">
          <div class="tit cor6">退款提醒：</div>
          <div class="flex cor-p">{{order.note}}</div>
        </div>
      </div>
    </div>
    <div class="desc bgF border-box mt15" v-if="order.info">
      <div class="info" v-html="order.info" id="descinfo">
      </div>
    </div>

    <div class="bot-box bgF border-box" v-if="!errmsg">
      <div class="fl btn line" @click="returnBack()">返回</div>
      <div class="fr btn linear" @click="cancelOrderFun()">确定</div>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {userPreRefund, userRefund} from "@/service/getData";
  import {wxGetPosition,wxShareme,} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        ordernum: this.$route.query.ordernum || '', //订单编码
        order: '', //订单详情
        errmsg: '', //不能退款提示信息

        P400: 0, //系统维护中

      }
    },
    created(){
      this.userInfo = getStore("userInfo");
      this.userPreRefundFun();
    },
    methods: {
      //取消订单（预取消）
      async userPreRefundFun(){
        let res = await userPreRefund({
          ordernum: this.ordernum,
      time: (new Date().getTime())
        });
        if(res.errcode == "00000"){
          this.order = res.data
        }else{
          this.errmsg = res.errmsg; //超过预约开始时间前一天下午4点,无法退款
          this.$toast(res.errmsg)
        }
      },

      //取消订单/申请退款
      cancelOrderFun: function (){
        var self = this;
        this.$confirm({
          title: '提示',
          content: '确认要取消此该订单吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.userRefundFun()
          }
        }).catch(function(res){
          if(res == 'success') {
            self.userRefundFun()
          }
        })
      },

      //确定取消订单
      async userRefundFun(){
        let res = await userRefund({
          ordernum: this.ordernum
        });
        if(res.errcode == "00000"){
          this.$toast("取消成功");

          var self = this;
          setTimeout(function(){
            self.$router.go(-1);//返回上一层
          },1500);
        }else{
          this.$toast(res.errmsg)
        }
      },

      //返回
      returnBack: function (){
        this.$router.go(-1);//返回上一层
      },

    },
    watch: {},
    components: {
        P400
    },
    filters:{
      setIdcard: function (str){
        return (str&&str.length)>=8?(str.substr(0,5)+"*****"+str.substr(-5)):str
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{min-height:100vh;padding: .3rem .3rem 1.2rem;background-color:#f2f2f2}
  .btn{width: 2.4rem;height: .72rem;margin-left:.16rem;font: .34rem/.72rem "Microsoft YaHei";}

  .desc{border-radius: .12rem;padding: 0 .3rem;}
  .info{ padding-top: .3rem;padding-bottom: .2rem; color: #333;}
  .info .box{padding: .2rem 0;font: .28rem/.48rem "Microsoft YaHei";}
  .info .box .tit{width: 1.6rem;}
  .bot-box{position: fixed;left: 0;bottom: 0;width: 100vw;height: 1.04rem;box-shadow: 0 0 .08rem rgba(0,0,0,.2);}
  .bot-box .btn{width:2.4rem;margin: .14rem .4rem 0;}
  .bot-box .btn.tc{ margin: .14rem auto 0; }

  .icon-tip{display:block;padding-top:.6rem;width: auto;height: 1.2rem;margin: 0 auto;}
  .tip{margin-top:.2rem;font: .34rem/.55rem "Microsoft YaHei";color: #333;text-align: center;}
  .tip1{padding-bottom:.5rem;margin-top:.4rem;font: .28rem/.55rem "Microsoft YaHei";color: #333;text-align: center;}

  #descinfo img{max-width: 100%}
</style>



// WEBPACK FOOTER //
// src/page/home/order-refund.vue